import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./menus.scss";
import { useSelector, useDispatch } from "react-redux";
import PopupConfirm from "@tw/shared-ui-components/lib/components/popupConfirm/popupConfirm";
import NewSpinner from "@tw/shared-ui-components/lib/components/newSpinner/newSpinner";
import { fetchUserMenuState, ac_enums, setState } from "../../redux/reducers";
import * as Icons from "./assets/icons/index.js";
import { constructMenu, findParentUID } from "./utils";
import { getLeftNavMapping } from "../../utils/helper";
import { getRouter, getQueryUTMString } from "@tw/shared-ui-components/lib/utils/helper";
import Cookies from "universal-cookie";
const Menus = (props) => {
  const { toggleCloseMenu, breakpoint, curAda } = props;
  let isDesktop = breakpoint !== "xs" && breakpoint !== "sm";
  const dispatch = useDispatch();
  const [showLogout, setShowLogout] = useState(false);
  const router = getRouter();
  // const NextLink = Link || "a";
  let loading = true;
  const cookie = new Cookies();
  const curRole = cookie.get("role");
  const menuData = useSelector((state) => {
    //console.log(state);
    return state.userState;
  });

  let menuList = [];
  if (typeof window !== "undefined") {
    if (
      menuData &&
      menuData.menuList &&
      menuData.menuList.length > 0 &&
      !localStorage.getItem("refreshMenu")
    ) {
      // check from state
      localStorage.setItem("menuList", JSON.stringify(menuData.menuList));
      menuList = menuData.menuList;
    }
    if (menuList.length === 0) {
      // get from backend, if not found from state
      let menuList_l = JSON.parse(localStorage.getItem("menuList") || "[]");
      if (menuList_l.length === 0) {
        dispatch(fetchUserMenuState(curRole));
        localStorage.removeItem("refreshMenu");
      } else {
        menuList = menuList_l;
      }
    }
  }

  // functions
  const handleExpandClick = (e) => {
    let curUid = e.target.getAttribute("uid");
    let parentList = menuData.parents || { list: [], currentParent: "" };

    if (parentList.list[curUid] !== undefined) {
      parentList.list[curUid] = !parentList.list[curUid];
      dispatch(setState(ac_enums.SET_USER_MENU_PARENT_STATE, parentList));
    }
  };

  // Process menu from contentstack
  let finalMenu = [];
  let parentList = [];
  let selectedSubMenuPath = "";
  let expandedList = { list: {}, currentParent: "" };
  if (menuData && menuData.parents) expandedList = menuData.parents;

  if (router && router.asPath) {
    selectedSubMenuPath = router.asPath.includes("?") ? router.asPath.split('?')[0] : router.asPath;
  }
  else if (router && router.location && router.location.pathname) {
    selectedSubMenuPath = router.location.pathname.includes("?") ? router.location.pathname.split('?')[0] : router.location.pathname;
  }
  //Map sub url to main url in menu
  selectedSubMenuPath = getLeftNavMapping(selectedSubMenuPath);

  if (selectedSubMenuPath === "/") selectedSubMenuPath = null;

  if (menuList.length > 0) {
    // construct menu structure
    [finalMenu, parentList] = constructMenu(menuList);
    if (menuData && !menuData.parents) {
      expandedList.list = parentList;
      dispatch(setState(ac_enums.SET_USER_MENU_PARENT_STATE, expandedList)); // set parents
    }
    loading = false;
  }

  let parentId =
    finalMenu.length > 0 ? findParentUID(finalMenu, selectedSubMenuPath) : "";
  if (
    parentId &&
    ((expandedList.currentParent === "" &&
      expandedList.list[parentId] !== undefined &&
      expandedList.list[parentId] === false) ||
      expandedList.currentParent !== parentId)
  ) {
    expandedList.list[parentId] = true;
    expandedList.currentParent = parentId;
    dispatch(setState(ac_enums.SET_USER_MENU_PARENT_STATE, expandedList));
  }

  let selectedParents = expandedList.list || [];
  const handleActionLogout = () => {
    setShowLogout(false);
    toggleCloseMenu();
    //logoutSession(router);
    router.push("/logout");
  };

  const handleActionCancel = () => {
    setShowLogout(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    setShowLogout(true);
  };

  let curPage = "";
  if (typeof window !== "undefined") {
    curPage = location.pathname;
  }
  const onToNextLink = (url) => {
    if (typeof window !== "undefined") {
      let param = `${url}${getQueryUTMString(url.includes("?") ? '&' : '?')}`
      router.push(param);
    }
  };
  return (
    <>
      {loading && (
        <div
          className={styles.spinner}
          style={{ height: isDesktop ? "600px" : "calc(100% - 200px)" }}
        >
          <NewSpinner />
        </div>
      )}
      {!loading && (
        <nav
          className={styles.nav}
          style={{ padding: isDesktop ? "10px" : "0 16px 16px" }}
        >
          {finalMenu &&
            finalMenu.length > 0 &&
            finalMenu.map((menu, i) => {
              let nav = menu.menu;
              let url = nav.target_url.link.href;
              if (url === "/login" && curPage) url += "?h=" + curPage;

              if (nav.title) {
                if (curAda && curAda !== "") {
                  if (menu.children.length > 0) {
                    let child = [];
                    if (selectedParents[menu.menu.uid]) {
                      menu.children.map((cNav, cIdx) => {
                        child.push(
                          <div
                            className={`${styles.navItem} ${selectedSubMenuPath &&
                              selectedSubMenuPath === cNav.target_url.link.href
                              ? styles.selected
                              : ""
                              }`}
                            onClick={toggleCloseMenu}
                            key={(i + 1) * 1000 + cIdx + 1}
                          >
                            <div
                              // href={cNav.target_url.link.href}
                              onClick={() =>
                                onToNextLink(cNav.target_url.link.href)
                              }
                              passHref
                            >
                              <a
                                target={`${cNav.target_url.tab_config === "new"
                                  ? "_blank"
                                  : ""
                                  }`}
                              >
                                <div className={styles.ico}></div>
                                <div className={styles.text}>{cNav.title}</div>
                              </a>
                            </div>
                          </div>
                        );
                      });
                    }
                    // parent menu
                    return (
                      <div key={(i + 1) * 100}>
                        <div className={`${styles.navItem}`} key={i}>
                          <a onClick={handleExpandClick} uid={nav.uid}>
                            <div className={styles.ico}>
                              <img src={nav.icon ? nav.icon.url : null} />
                            </div>
                            <div className={styles.text}>{nav.title}</div>
                          </a>
                          <div
                            className={styles.arrow}
                            onClick={handleExpandClick}
                            uid={nav.uid}
                          >
                            <img
                              style={{ verticalAlign: "middle" }}
                              src={Icons.ArrowDown.default}
                              className={`${styles.expandIcon} ${selectedParents[nav.uid] ? styles.edgeEnd : ""
                                }`}
                            />
                          </div>
                        </div>
                        {child}
                      </div>
                    );
                  } else {
                    // no child
                    if (url === "/logout") {
                      return (
                        <div className={`${styles.navItem}`} key={i}>
                          <a onClick={handleLogout} uid={nav.uid}>
                            <div className={styles.ico}>
                              <img src={nav.icon ? nav.icon.url : null} />
                            </div>
                            <div className={styles.text}>{nav.title}</div>
                          </a>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className={`${styles.navItem} ${selectedSubMenuPath && selectedSubMenuPath === url
                            ? styles.selected
                            : ""
                            }`}
                          onClick={toggleCloseMenu}
                          key={i}
                        >
                          <div
                            onClick={() => onToNextLink(url)}
                            // href={url}
                            passHref
                          >
                            <a
                              target={`${nav.target_url.tab_config === "new"
                                ? "_blank"
                                : ""
                                }`}
                            >
                              <div className={styles.ico}>
                                <img src={nav.icon ? nav.icon.url : null} />
                              </div>
                              <div className={styles.text}>{nav.title}</div>
                            </a>
                          </div>
                        </div>
                      );
                    }
                  }
                } else {
                  // no child
                  if (url === "/logout") {
                    return (
                      <div className={`${styles.navItem}`} key={i}>
                        <a onClick={handleLogout} uid={nav.uid}>
                          <div className={styles.ico}>
                            <img src={nav.icon ? nav.icon.url : null} />
                          </div>
                          <div className={styles.text}>{nav.title}</div>
                        </a>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={`${styles.navItem} ${selectedSubMenuPath && selectedSubMenuPath === url
                          ? styles.selected
                          : ""
                          }`}
                        onClick={toggleCloseMenu}
                        key={i}
                      >
                        <div
                          onClick={() => onToNextLink(url)}
                          // href={url}
                          passHref
                        >
                          <a
                            target={`${nav.target_url.tab_config === "new"
                              ? "_blank"
                              : ""
                              }`}
                          >
                            <div className={styles.ico}>
                              <img src={nav.icon ? nav.icon.url : null} />
                            </div>
                            <div className={styles.text}>{nav.title}</div>
                          </a>
                        </div>
                      </div>
                    );
                  }
                }
              }
            })}
        </nav>
      )}
      <PopupConfirm
        title="帳號登出"
        showPopup={showLogout}
        okBtn={{
          text: "確認",
          action: handleActionLogout,
        }}
        cancelBtn={{
          text: "取消",
          action: handleActionCancel,
        }}
      >
        <span>您即將登出目前帳號</span>
      </PopupConfirm>
    </>
  );
};

Menus.defaultProps = {
  toggleCloseMenu: () => { },
};

Menus.propTypes = {
  toggleCloseMenu: PropTypes.func,
};

export default Menus;
